<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">{{'Capitaline API'}}</strong>
        </div>
        <div class="col-md-2">
          <download :tableId="'capitaline-apis'" :fileName="'capitaline-apis'"></download>
        </div>
        <!-- <div class="col-md-1">
          <goback></goback>
        </div>-->
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-9 br">
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <input
              type="text"
              v-model="searchText"
              class="form-control"
              name="search"
              placeholder="Search"
              @keyup="search($event)"
            />
          </div>
        </div>
      </div>
      <div class="table-responsive app" v-dragscroll="true">
        <table
          id="capitaline-apis"
          class="table table-sm first-td-padding table-bordered app-inner"
        >
          <thead>
            <tr>
              <th>Sr.</th>
              <th v-for="field in tableFields" v-bind:key="'field'+field.title">{{field.title}}</th>
              <th v-if="actions.length>0">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row,index) in fillableData" v-bind:key="'row'+index">
              <td>
                <span>{{(index+1)}}</span>
              </td>
              <td v-for="field in tableFields" v-bind:key="field.name+index">
                <span v-if="field.name==='date'">{{getDateTime(row[field.name])}}</span>
                <span v-else>{{row[field.name]}}</span>
              </td>
              <td v-if="actions.length>0">
                <div class="action-btn-wrapper">
                  <a
                    style="margin:1px 4px"
                    class="btn btn-sm btn-small"
                    :class="action.btnClass"
                    v-for="action in actions"
                    v-bind:key="'action'+action.tooltip"
                    @click.prevent="action.callback(row,index,$event)"
                  >
                    <i :title="action.tooltip" class="fa" :class="action.icon"></i>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="fillableData.length==0">
            <tr>
              <td :colspan="(tableFields.length+actions.length+1)">
                <i class="fa fa-info cwhite"></i> No data found.
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <!-- </card> -->
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";

export default {
  mixins: [commonMixins],
  name: "CapitalineApi",
  created() {
    this.fetchData();
  },
  data() {
    return {
      apiUrl: "CapitalineAPI/list",
      pageType: "capitaline-apis",
      apiMode: true,
      actions: [],
      tableFields: [
        {
          name: "name",
          title: "Name"
        },
        {
          name: "api",
          title: "API Link"
        }
      ],
      searchText: "",
      fillableData: [],
      searchData: []
    };
  },
  methods: {
    search(e) {
      if (this.searchText.length > 2 || e.keyCode === 13) {
        this.fillableData = this.searchData.filter(field => {
          console.log("export field", field);
          if (field.name) {
            return (
              field.name
                .toLowerCase()
                .includes(this.searchText.toLowerCase()) ||
              field.api.toLowerCase().includes(this.searchText.toLowerCase())
            );
          } else {
            return field.api
              .toLowerCase()
              .includes(this.searchText.toLowerCase());
          }
        });
      }
      if (
        this.searchText === null ||
        this.searchText === "" ||
        this.searchText.length <= 2
      ) {
        this.fillableData = this.searchData;
        return this.fillableData;
      }
    },
    fetchData(data = null) {
      let myself = this;
      http.get(this.apiUrl, {}, function(error, response) {
        console.log(response);
        myself.fillableData = response;
        myself.searchData = response;
      });
    }
  }
};
</script>
<style>
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/reports/capitaline-apis.vue